//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ArrangeImages',
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    activePadding: function activePadding() {
      var _this$propsData;
      if (!this.propsData.activePadding) {
        return '';
      }
      var _ref = ((_this$propsData = this.propsData) === null || _this$propsData === void 0 ? void 0 : _this$propsData.activePadding) || {},
        pt = _ref.pt,
        pr = _ref.pr,
        pb = _ref.pb,
        pl = _ref.pl;
      return "".concat(pt || 0, "px ").concat(pr || 0, "px ").concat(pb || 0, "px ").concat(pl || 0, "px");
    }
  }
};